import { gql } from '@apollo/client';

export const GET_MAKE_IDS = gql`
  query GetMakeIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowAssemblyMakes(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
    }
  }
`;

export const GET_MAKES = gql`
  query GetMakes(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowAssemblyMakes(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      name
      visible
    }
  }
`;

export type MakeItem = {
  id: string;
  name: string;
  visible: boolean;
};
